import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config";
import useLogout from "../Auth/useLogout";
import placeImage from "../../images/placeholder.jpg";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";

export default function TransporterVehicle() {
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [vehicleList, setVehicleList] = useState([]);

    const logout = useLogout();

    const imageOnError = (event) => {
        event.currentTarget.src = placeImage;
    };

    const fetchVehicle = useCallback(async () => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${config.apiUrl}/transporter/vehicle`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: config.token,
                    Accept: "application/json",
                },
            });

            setVehicleList(response.data.list);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                logout();
            }
        } finally {
            setDataLoading(false);
        }
    }, [logout]);

    useEffect(() => {
        fetchVehicle();
    }, [fetchVehicle]);

    const handleVehicleChange = (index) => {
        if (index !== null) {
            const updateData = [...vehicleList];
            updateData[index].is_selected = updateData[index].is_selected
                ? false
                : true;
            setVehicleList(updateData);
        }
    };

    const handleVehicleSubmit = async (e) => {
        e.preventDefault();

        const vehicle_id = vehicleList
            .filter((item) => item.is_selected)
            .map((item) => item.id);

        if (vehicle_id.length > 0) {
            setLoading(true);
            try {
                const response = await axios.post(
                    `${config.apiUrl}/transporter/assign-vehicle`,
                    { vehicle: vehicle_id },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: config.token,
                            Accept: "application/json",
                        },
                    }
                );
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } catch (error) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                if (error.response && error.response.status === 401) {
                    logout();
                }
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Please select a vehicle", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    return (
        <>
            {dataLoading ? (
                <div className="d-flex justify-content-center">
                    <Dataloader />
                </div>
            ) : (
                <>
                    {vehicleList.length > 0 ? (
                        <form onSubmit={handleVehicleSubmit}>
                            <div className="row g-3">
                                {vehicleList.map((vehicle, index) => (
                                    <div className="col-lg-4 px-2" key={index}>
                                        <div className="order-product">
                                            <div className="row py-2 align-items-center">
                                                <div className="col-3">
                                                    <div
                                                        className="order-image"
                                                        style={{ height: "60px" }}
                                                    >
                                                        <img
                                                            src={vehicle.photo}
                                                            onError={imageOnError}
                                                            alt={vehicle.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-9 ps-0">
                                                    <div className="order-detail">
                                                        <h6 className="one-line-clamp">{vehicle.name}</h6>
                                                        <div className="order-tag">
                                                            <div>
                                                                <span className="f-500">Type:</span>
                                                                <span>{vehicle.type}</span>
                                                            </div>
                                                            <div>
                                                                <span className="f-500">Capacity:</span>
                                                                <span>{vehicle.capacity} Ton</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="abs_check">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input custom_check"
                                                        type="checkbox"
                                                        checked={vehicle.is_selected}
                                                        onChange={() => handleVehicleChange(index)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="col-lg-12 px-2 text-end">
                                    <button
                                        type="submit"
                                        title="Update Profile"
                                        className="submit_btn"
                                        disabled={loading}
                                    >
                                        <i className="bi bi-floppy"></i>
                                        {loading ? "Submitting" : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <NoData />
                    )}
                </>
            )}
        </>
    );
}
